var _defs, _path, _path2, _path3, _path4, _polygon, _path5, _path6, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassenger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 163 138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f2f2;stroke:#000;stroke-miterlimit:10;}.cls-2{fill:#009cdb;}.cls-3{fill:#fff;fill-rule:evenodd;}.cls-4{fill:#191919;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147,136H2.69V9.65H147a5.19,5.19,0,0,1,5.18,5.18v116A5.19,5.19,0,0,1,147,136Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.11,21.06,35.23,25s4.52,3.17,5.92,6.17a35.65,35.65,0,0,1,2.64,10.23c0,1.69-1,93.93-1,93.93v.27l-39.64,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3,106H25.92a5,5,0,0,0,5-5l2.45-27a5,5,0,0,0-5-5L3,68.29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.92,107.07H3V105H25.92a4,4,0,0,0,3.94-3.94V101L32.3,74a3.94,3.94,0,0,0-3.93-3.89L3,69.33l.06-2.07L28.4,68h0a6,6,0,0,1,6,6v.09l-2.44,27A6,6,0,0,1,25.92,107.07Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "38.31 95.37 38.31 133.3 30.89 133.3 30.89 114.72 38.31 95.37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.31,134.33H30.89a1,1,0,0,1-1-1V114.72a.94.94,0,0,1,.07-.37L37.34,95a1,1,0,0,1,2,.37V133.3A1,1,0,0,1,38.31,134.33Zm-6.38-2.07h5.35V101l-5.35,13.94Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.82,135.74H42.75V41.38C42.75,31.23,36,26.67,34.89,26L2.77,22l.26-2L35.55,24l.18.09c.37.2,9.09,5.08,9.09,17.31Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 53,
    y: 80,
    fill: "black",
    fontFamily: "OpenSans-Regular, Open Sans, sans-serif",
    fontSize: "9pt"
  }, "Passenger")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassenger);
export default __webpack_public_path__ + "static/media/passenger.40028d8e1c1d96864e3e3d4633efda0e.svg";
export { ForwardRef as ReactComponent };